import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import {
  getSubCategoriesList,
  getCategories,
} from "../../redux/actions/indexActions";
import { toast } from "react-toastify";
const EditOffer = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_id: "",
    place_id: "",
    title: "",
    status: 1,
    type: "",
    thumbnail: "",
    amount: 0,
  });
  const [errors, setErrors] = useState({});
  const [subCategories, setSubCategories] = useState([]);
  const [places, setPlaces] = useState([]);
  const {
    AuthReducer: { auth },
    indexReducer: { categoriesList }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSubmit = () => {
    const form = new FormData();
    for (const key in formData) {
      if (key === "category_id") {
        form.append("category_id", formData[key]);
      }
      form.append([key], formData[key]);
    }
    axios
      .put(`/api/admin/v1/offer/${id}`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };

  useEffect(() => {
    axios(`/api/admin/v1/offer-update/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    })
      .then((res) => {
        setFormData({
          category_id: res.data?.offers?.category_id,
          sub_category_id: res.data?.offers?.sub_category_id,
          place_id: res.data?.offers?.place_id,
          title: res.data?.offers?.title,
          type: res.data?.offers?.type,
          amount: res.data?.offers?.amount,
          status: res.data?.offers?.status,
        });
      })
      .catch((err) => console.log(err));
  }, [auth]);

  useEffect(() => {
    dispatch(getCategories(auth.token));
    dispatch(getSubCategoriesList(auth.token));
  }, [auth]);

  useEffect(() => {
    if (formData.category_id) {
      axios(`/api/admin/v1/get-subcategory-by-category/${formData.category_id}`)
        .then(({ data }) => {
          setSubCategories(data?.subCategoriesbyCategory);
        })
        .catch((err) => console.error(err));
    } else {
      setSubCategories([]);
    }
  }, [formData.category_id]);

  useEffect(() => {
    if (formData.sub_category_id) {
      axios(`/api/admin/v1/get-places-by-subcategory/${formData.sub_category_id}`)
        .then(({ data }) => {
          setPlaces(data?.data);
        })
        .catch((err) => console.error(err));
    } else {
      setPlaces([]);
    }
  }, [formData.sub_category_id]);

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h5 className="text-white">Edit Offer</h5>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Title <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.title)}
                value={formData?.title}
                name="title"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.title} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Thumbnail</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.thumbnail)}
                name="thumbnail"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.thumbnail}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.category_id}
                type="select"
                name="category_id"
                onChange={inputHandler}
              >
                <option value="">Select Category</option>
                {categoriesList?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.category_id}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Sub Category<span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.sub_category_id)}
                value={formData?.sub_category_id}
                type="select"
                name="sub_category_id"
                onChange={inputHandler}
              >
                <option value="">Select Sub Category</option>
                {subCategories?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.name_english}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.sub_category_id}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Place<span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.place_id)}
                value={formData?.place_id}
                type="select"
                name="place_id"
                onChange={inputHandler}
              >
                <option value="">Select Place</option>
                {places?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.place_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.place_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Type <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.type}
                type="select"
                name="type"
                onChange={inputHandler}
              >
                <option value="">Select</option>
                <option value="Free">Free</option>
                <option value="Paid">Paid</option>
              </Input>
              <span className="d-block text-danger">{errors?.type}</span>
            </FormGroup>
          </div>
          {formData.type == "Paid" ? (
            <div className="col-md-4 offset-md-1">
              <FormGroup>
                <Label>Amount</Label>
                <Input name="amount" value={formData.amount} onChange={inputHandler} />
              </FormGroup>
            </div>
          ) : null}

          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOffer;
